import { extend } from 'sk-ui/lib/utils/util.js'

import reportForm from './metaData/reportForm'
import periForm from './metaData/reportPersonalPeriForm'
import softForm from './metaData/reportPersonalSoftForm'

import productOsTypeRelate from '@/components/ProductOsTypeRelate'
export default {
  changeUploadAction({ commit }, { rootView, value }) {
    let action = rootView.views.okAction
    if (action === 'personalSoftCompatibleUpload') {
      rootView.views.okAction = 'personalSoftCompatibleUploadWithFile'
    } else if (action === 'personalSoftCompatibleUploadWithFile') {
      rootView.views.okAction = 'personalSoftCompatibleUpload'
    } else if (action === 'personalPeriCompatibleUpload') {
      rootView.views.okAction = 'personalPeriCompatibleUploadWithFile'
    } else if (action === 'compatibleReUpload') {
      rootView.views.okAction = 'compatibleReUploadWithFile'
    } else if (action === 'compatibleReUploadWithFile') {
      rootView.views.okAction = 'compatibleReUpload'
    }
  },
  pushToYunZhi({ commit }, params) {
    var title = '软件/外设兼容性上报到云智助手'
    if (params.row.hasPush) {
      title = title + ',【' + params.row.name + '】已上报，是否重新上报？'
    }
    var dialog = params.viewController.$dialog({
      template: h => {
        const row = params.row
        return (
          <sky-product-os-type-relate
            row={row}
            onCb={function() {
              dialog.remove()
              params.viewController.fetch()
            }}
          />
        )
      },
      components: {
        productOsTypeRelate
      },
      props: {
        title: title,
        width: '45%',
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false
      }
    })
  },
  compatibleReUpload({ commit }, params) {
    const props = {
      params: { collectId: params.row.collectId, projectId: params.row.projectId },
      extraParams: params.row,
      'view.content[$id=compatibleList].$el': { row: params.row }
    }
    const reportFormCopy = extend(true, {}, reportForm)
    this.dispatch('OpenFullDialog', { metaData: reportFormCopy, props, clone: false })
  },
  personalSoftCompatibleUpload({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: softForm,
      props
    })
  },
  personalPeriCompatibleUpload({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: periForm,
      props
    })
  }
}
